<template>
    <section>
        <FormSection
            :full-height="false"
            :title="visitDetails.TaskName"
            :application-id="visitDetails.Application"
            :show-product-pill="true"
        >
            <template #content>
                <template v-if="isLoading">
                    <div class="p-5 d-flex flex-column text-center text-primary">
                        <i class="fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite"></i>
                        <strong class="mt-1">
                            <b>Loading...</b>
                        </strong>
                    </div>
                </template>
                <template v-else>
                    <div class="task-details position-relative">
                        <div class="dialog container row m-0 p-1">
                            <div
                                v-if="visitDetails.isEmployeeCalendar && !visitDetails.IsNonVisitAssignment"
                                class="col-12 my-1 ps-3"
                            >
                                <b
                                    >Patient Name: {{ visitDetails.PatientFirstName }}
                                    {{ visitDetails.PatientLastName }}</b
                                >
                            </div>
                            <div class="form-group col-6 mt-2" v-if="!visitDetails.IsNonVisitAssignment">
                                <label for="employee-from"> Status: </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    :value="taskDetails.scheduleEvent.status"
                                    placeholder=""
                                    disabled
                                />
                            </div>
                            <div v-if="!visitDetails.IsNonVisitAssignment" class="form-group col-6 mt-2">
                                <label for="schedule-date"> Schedule Date: <span class="text-danger">*</span></label>
                                <DatePicker :getDate="handleDateChange">
                                    <div class="input-group date datepickerInput">
                                        <input
                                            name="eventDate"
                                            type="text"
                                            class="form-control"
                                            :value="formatDateInput(taskDetails.scheduleEvent.eventDate)"
                                            @change="(e) => handleDateChange(e.target.value, 'eventDate')"
                                            :disabled="areFieldsEnabled"
                                            @blur="v$.taskDetails.scheduleEvent.eventDate.$touch"
                                        />
                                        <div class="input-group-addon input-group-append">
                                            <div class="input-group-text">
                                                <i class="fa fa-calendar"></i>
                                            </div>
                                        </div>
                                    </div>
                                </DatePicker>
                                <span v-if="v$.taskDetails.scheduleEvent.eventDate.$error" class="field-invalid"
                                    >Schedule date is required.</span
                                >
                            </div>
                            <div v-else class="form-group col-6 mt-2">
                                <label for="schedule-date">Date: <span class="text-danger">*</span></label>
                                <DatePicker :getDate="handleDateChange">
                                    <div class="input-group date datepickerInput">
                                        <input
                                            name="nvaStartDate"
                                            type="text"
                                            class="form-control"
                                            :value="formatDateInput(taskDetails.scheduleEvent.nvaStartDate)"
                                            @change="(e) => handleDateChange(e.target.value, 'nvaStartDate')"
                                        />
                                        <div class="input-group-addon input-group-append">
                                            <div class="input-group-text">
                                                <i class="fa fa-calendar"></i>
                                            </div>
                                        </div>
                                    </div>
                                </DatePicker>
                                <span v-if="v$.taskDetails.scheduleEvent.nvaStartDate.$error" class="field-invalid"
                                    >date is required.</span
                                >
                            </div>
                            <div class="form-group col-6" v-if="!visitDetails.IsNonVisitAssignment">
                                <label for="assigned-to"> Assigned To: </label>
                                <input type="text" class="form-control" :value="assignedToName" disabled />
                            </div>
                            <div class="form-group col-6" v-if="!visitDetails.IsNonVisitAssignment">
                                <label for="payers"> Payer: </label>
                                <select
                                    id="payers"
                                    class="form-select"
                                    v-model="taskDetails.scheduleEvent.payer"
                                    :disabled="isPlanner"
                                >
                                    <option :value="null">Select Payment Source</option>
                                    <option v-for="(payer, index) of payers" :key="index" :value="payer.id">
                                        {{ payer.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group col-6">
                                <label for="visit-start-time">
                                    {{
                                        !visitDetails.IsNonVisitAssignment
                                            ? "Visit Start Time:"
                                            : !isPalliative
                                              ? "Time In:"
                                              : "Non-Patient Activity Start Time: "
                                    }}

                                    <span class="text-danger" v-if="this.isVisitTimeRequired && !this.isPlanner"
                                        >*</span
                                    ></label
                                >
                                <TimePicker @update-props="changetimeIn">
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="taskDetails.scheduleEvent.timeIn"
                                        autocomplete="off"
                                        maxlength="8"
                                        placeholder="Enter Time"
                                        :disabled="isSavedOrCompleted || isPlanner"
                                        @blur="v$.taskDetails.scheduleEvent.timeIn.$touch"
                                    />
                                </TimePicker>
                                <span v-if="v$.taskDetails.scheduleEvent.timeIn.$error" class="field-invalid"
                                    >Visit Start time is required.</span
                                >
                            </div>
                            <div class="form-group col-6">
                                <label for="visit-start-time">
                                    {{
                                        !visitDetails.IsNonVisitAssignment
                                            ? "Visit End Time:"
                                            : !isPalliative
                                              ? "Time Out:"
                                              : "Non-Patient Activity End Time: "
                                    }}

                                    <span class="text-danger" v-if="this.isVisitTimeRequired && !this.isPlanner"
                                        >*</span
                                    ></label
                                >
                                <TimePicker @update-props="changetimeOut">
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="taskDetails.scheduleEvent.timeOut"
                                        placeholder="Enter Time"
                                        autocomplete="off"
                                        maxlength="8"
                                        :disabled="isSavedOrCompleted || isPlanner"
                                        @blur="v$.taskDetails.scheduleEvent.timeOut.$touch"
                                    />
                                </TimePicker>
                                <span v-if="v$.taskDetails.scheduleEvent.timeOut.$error" class="field-invalid"
                                    >Visit End time is required.</span
                                >
                            </div>
                            <div class="form-group col-6">
                                <label for="travel-start-time">
                                    {{
                                        !visitDetails.IsNonVisitAssignment
                                            ? "Travel Start Time:"
                                            : isPalliative
                                              ? "Travel Start Time"
                                              : "Travel Time In"
                                    }}
                                </label>
                                <TimePicker @update-props="changeTravelTimeIn">
                                    <input
                                        type="text"
                                        class="form-control"
                                        :value="taskDetails.scheduleEvent.travelTimeIn"
                                        placeholder="Enter Time"
                                        autocomplete="off"
                                        maxlength="8"
                                        :disabled="isSavedOrCompleted || isPlanner"
                                    />
                                </TimePicker>
                            </div>
                            <div class="form-group col-6">
                                <label for="travel-start-time">
                                    {{
                                        !visitDetails.IsNonVisitAssignment
                                            ? "Travel End Time:"
                                            : isPalliative
                                              ? "Travel End Time"
                                              : "Travel Time Out:"
                                    }}
                                </label>
                                <TimePicker @update-props="changeTravelTimeOut">
                                    <input
                                        type="text"
                                        class="form-control"
                                        :value="taskDetails.scheduleEvent.travelTimeOut"
                                        placeholder="Enter Time"
                                        autocomplete="off"
                                        maxlength="8"
                                        :disabled="isSavedOrCompleted || isPlanner"
                                    />
                                </TimePicker>
                            </div>
                            <div class="form-group col-4" v-if="isPalliative && !visitDetails.IsNonVisitAssignment">
                                <label for="documentation-time"> Documentation Time(Minutes): </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="taskDetails.scheduleEvent.documentationTime"
                                    placeholder="Enter Time"
                                    :disabled="isSavedOrCompleted || isPlanner"
                                />
                            </div>
                            <div class="form-group col-6">
                                <label for="associated-mileage"> Associated Mileage: </label>
                                <input
                                    type="text"
                                    v-model="taskDetails.scheduleEvent.associatedMileage"
                                    class="form-control"
                                    placeholder="Enter Mileage"
                                    :disabled="isSavedOrCompleted || isPlanner"
                                />
                            </div>
                            <div class="form-group col-6">
                                <label for="surcharge"> Surcharge: </label>
                                <a
                                    tabindex="0"
                                    href="javascript:void(0);"
                                    role="button"
                                    v-custom-popover="{ content: sanitizeMarkup(surchargeTooltip) }"
                                >
                                    <i class="fas fa-info-circle text-primary font-size-xs"></i>
                                </a>
                                <input
                                    type="text"
                                    v-model="taskDetails.scheduleEvent.surcharge"
                                    class="form-control"
                                    placeholder="Enter Amount"
                                    :disabled="isSavedOrCompleted || isPlanner"
                                />
                            </div>
                            <div class="form-group col-4" v-if="isPalliative && !visitDetails.IsNonVisitAssignment">
                                <label> Visit Type </label>
                                <div class="d-flex">
                                    <div class="form-check custom-radio col-5 mt-2">
                                        <input
                                            type="radio"
                                            id="on-call"
                                            name="on-call-prn"
                                            class="form-check-input"
                                            :checked="taskDetails.scheduleEvent.isCallVisit"
                                            @change="updateVisitType(true, false)"
                                            :disabled="isPlanner"
                                        />
                                        <label class="form-check-label" for="on-call">
                                            <span class="me-1">On-Call</span>
                                        </label>
                                    </div>
                                    <div
                                        v-if="!visitDetails.IsNonVisitAssignment"
                                        class="form-check custom-radio col-5 mt-2"
                                    >
                                        <input
                                            type="radio"
                                            id="prn"
                                            name="on-call-prn"
                                            class="form-check-input"
                                            :checked="taskDetails.scheduleEvent.isPRNVisit"
                                            @change="updateVisitType(false, true)"
                                            :disabled="isPlanner"
                                        />
                                        <label class="form-check-label" for="prn">
                                            <span class="me-1">PRN</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="!visitDetails.IsNonVisitAssignment"
                                :class="`form-group ${isPalliative ? 'col-4' : 'col-6'}`"
                            >
                                <label for="confirmation-status"> Confirmation Status </label>
                                <select
                                    id="confirmation-status"
                                    class="form-select"
                                    v-model="confirmationStatus"
                                    :disabled="isConfirmationStatusEnabled"
                                >
                                    <option :value="0">Select Confirmation Status</option>
                                    <option
                                        v-for="[index, status] in enumToMap(confirmationStatusEnum)"
                                        :value="status.value"
                                        :key="status.value"
                                    >
                                        {{ status.name }}
                                    </option>
                                </select>
                            </div>
                            <div
                                v-if="!visitDetails.IsNonVisitAssignment"
                                :class="`form-group col-4 ${isPalliative ? 'col-4' : 'col-6'}`"
                            >
                                <label> Accounting Type </label>
                                <div class="d-flex">
                                    <div class="form-check custom-checkbox col-4 mt-2">
                                        <input
                                            type="checkbox"
                                            id="billable"
                                            class="form-check-input"
                                            v-model="taskDetails.scheduleEvent.isBillable"
                                            :disabled="isPlanner"
                                        />
                                        <label class="form-check-label" for="billable"> Billable </label>
                                    </div>
                                    <div class="form-check custom-checkbox col-4 mt-2">
                                        <input
                                            type="checkbox"
                                            id="payable"
                                            class="form-check-input"
                                            v-model="taskDetails.scheduleEvent.isPayable"
                                            :disabled="isPlanner"
                                        />
                                        <label class="form-check-label" for="payable"> Payable </label>
                                    </div>
                                    <div class="form-check custom-checkbox col-4 mt-2" v-if="!isPalliative">
                                        <input
                                            type="checkbox"
                                            id="on-call-visit"
                                            class="form-check-input"
                                            v-model="taskDetails.scheduleEvent.isCallVisit"
                                            :disabled="isPlanner"
                                        />
                                        <label class="form-check-label" for="on-call-visit"> On-Call Visit </label>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="!visitDetails.IsNonVisitAssignment"
                                :class="`form-group ${isPalliative ? 'col-6' : 'col-3'}`"
                            >
                                <label for="auto-calculated-travel-time"> Auto-Calculated Travel Time: </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="taskDetails.scheduleEvent.autoCalculatedTravelTime"
                                    disabled
                                />
                            </div>
                            <div
                                v-if="!visitDetails.IsNonVisitAssignment"
                                :class="`form-group ${isPalliative ? 'col-6' : 'col-3'}`"
                            >
                                <label for="auto-calculated-mileage"> Auto-Calculated Mileage </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="taskDetails.scheduleEvent.autoCalculatedMileage"
                                    disabled
                                />
                            </div>
                            <section v-if="showComments" class="d-flex flex-column col-12 px-3 py-2" slot="content">
                                <div class="form-group">
                                    <label for="comments">
                                        Task Notes <i class="ms-2 fas fa-sticky-note yellow-note"></i> (Yellow Sticky
                                        Note)
                                    </label>
                                    <CommentInput
                                        id="notes"
                                        input-name="task-notes"
                                        placeholder="Enter Task Notes"
                                        :application="visitDetails.Application"
                                        :show-template-typeahead="false"
                                        :show-template-dropdown="false"
                                        :result="assignedToTaskNotes"
                                        v-on:resultUpdatedAppended="resultUpdatedAppended"
                                        v-on:resultUpdated="resultUpdated"
                                        disabled
                                    />
                                </div>
                            </section>
                            <section
                                v-if="!visitDetails.IsNonVisitAssignment"
                                class="d-flex flex-column col-12 px-3 py-2"
                            >
                                <div class="form-group">
                                    <label for="narrative">
                                        Missed Visit Detail <i class="ms-2 fas fa-sticky-note red-note"></i> (Red Sticky
                                        Note)
                                    </label>
                                    <div :class="`mb-2 mt-2`">
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Reason For Missed Visit"
                                            :value="assignedToMissedVisitFormReturnReason"
                                            disabled
                                        />
                                    </div>
                                    <CommentInput
                                        id="narrative"
                                        input-name="referral-narrative"
                                        placeholder="Enter Narrative"
                                        :application="visitDetails.Application"
                                        :show-template-typeahead="false"
                                        :show-template-dropdown="false"
                                        :result="assignedToComments"
                                        v-on:resultUpdatedAppended="resultUpdatedNarrativeAppended"
                                        v-on:resultUpdated="resultUpdatedNarrative"
                                        disabled
                                    />
                                </div>
                            </section>
                            <section
                                v-if="!visitDetails.IsNonVisitAssignment"
                                class="d-flex flex-column col-12 px-3 py-2"
                                slot="content"
                            >
                                <div class="form-group">
                                    <label for="comments">
                                        Return Reason <i class="ms-2 fas fa-sticky-note orange-note"></i> (Orange Sticky
                                        Note)
                                    </label>
                                    <CommentInput
                                        id="comments"
                                        input-name="referral-comments"
                                        placeholder="Enter Comments"
                                        :application="visitDetails.Application"
                                        :show-template-typeahead="false"
                                        :show-template-dropdown="false"
                                        :result="assignedToReturnReason"
                                        v-on:resultUpdatedAppended="resultUpdatedAppended"
                                        v-on:resultUpdated="resultUpdated"
                                        disabled
                                    />
                                </div>
                            </section>
                            <div v-if="!visitDetails.IsNonVisitAssignment" class="col-12">
                                <VisitDocumentsHosPal :visitDetails="visitDetails" :isPlanner="isPlanner" />
                            </div>
                        </div>
                        <div
                            :class="`d-flex justify-content-center mb-3 mt-3 position-sticky p-2 z-index-10 bottom-0 ${
                                isPalliative ? 'bg-form-palliative-section' : 'bg-form-section'
                            }`"
                            v-if="!isLoading"
                        >
                            <span v-if="isSaving">
                                <button class="btn btn-primary">
                                    <i class="fa fa-spinner fa-spin animated slow flash infinite"></i>
                                </button>
                            </span>
                            <span v-else>
                                <button class="btn btn-primary" @click="saveVisit()">Save</button>
                                <button
                                    type="button"
                                    class="ms-1 btn btn-md btn-outline-secondary"
                                    @click="closeDialog()"
                                >
                                    Cancel
                                </button>
                            </span>
                        </div>
                    </div>
                </template>
            </template>
        </FormSection>
    </section>
</template>

<style src="../VisitDetailsHomeCare/VisitDetailsHomeCare.scss"></style>
<script src="./VisitDetailsHosPal.ts"></script>
